"use strict";

/**
 * 捕捉window上的JS错误
 * @param {ErrorManager} manager - 错误管理实例
 */
module.exports = function (manager) {
    var windowError = window.onerror;

    if (!manager) return;

    var cfgManager = manager.cfgManager;
    if (cfgManager.get('autoCatch').js !== false) {
        //  监听暴露在全局的JS错误
        window.onerror = function () {
            manager.parseWindowError.apply(manager, arguments);
            windowError && windowError.apply(window, arguments);
        };
        var ADD_EVENT = window.addEventListener || window.attachEvent;
        ADD_EVENT("unhandledrejection", function () {
            manager.parsePromiseUnhandled.apply(manager, arguments);
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/owl/lib/error/catch.js
// module id = 246
// module chunks = 0